import React from 'react';
import PropTypes from 'prop-types';
import { TabPane } from 'reactstrap';

export const TabDetails = ({ component: Component, tabId, ...rest }) => {
  return (
    <TabPane tabId={tabId}>
      <Component category={tabId} {...rest} />
    </TabPane>
  );
};

TabDetails.propTypes = {
  tabId: PropTypes.string.isRequired,
  component: PropTypes.object
};
